import produce from 'immer';
import decodeEmbedding from './decodeEmbedding';
const enrichClassifications = (comparisonDocuments) => {
    return produce(comparisonDocuments, draft => {
        draft.forEach(doc => {
            doc.classifications.forEach(classification => {
                var _a, _b, _c, _d, _e, _f;
                classification.category = classification.name.split(':')[0];
                classification.displayName = (_b = (_a = classification.name.split(':')) === null || _a === void 0 ? void 0 : _a[1]) === null || _b === void 0 ? void 0 : _b.trim();
                classification.descriptor = (_d = (_c = classification.name.split(':')) === null || _c === void 0 ? void 0 : _c[1]) === null || _d === void 0 ? void 0 : _d.trim();
                classification.embedding = decodeEmbedding((_f = (_e = classification.regions) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.embedding);
            });
        });
    });
};
export default enrichClassifications;
